import { computed } from "vue";

export default {
  // notice: please use with SimpleInputMixin!
  // mixins: [SimpleInputMixin],
  inheritAttrs: false,
  props: {
    themes: {
      type: [Array],
      default: () => {
        return config.style.weUI.themes;
      }
    },
  },
  data() {
    return {};
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    computedTheme() {
      if (typeof this.value === "string") {
        return this.value;
      }

      return "";
    },
    computedThemeCssValue() {
      if (!this.computedTheme || this.computedTheme === "") {
        return `repeating-conic-gradient(var(--c-gray-2) 0% 25%, var(--c-bg) 0% 50%)
    50%/ 10px 10px`;
      }
      return `var(--c-${this.computedTheme})`;
    },
    internalThemeList() {
      return this.themes.map((key) => ({
        value: key,
        label: `theme.colors.${key}`,
      }));
    },
    safeAttrs() {
      let base = { ...this.$attrs };
      delete base.class;
      delete base.validationMessage;
      return base;
    },
  },
  methods: {},
  created() {},
};
